import { param } from "framer-motion/client";
import { ENDPOINTS } from "../../apiConfig";
import axiosRequest from "../universal/axiosService";


export const fetchAccountDetails = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.JOBS.GET_ALL,
    params: {
      coll: params.coll,
      fil: JSON.stringify(params.filters),
      ref: params.ref || null,
      lim: params.lim || 10,
      pg: params.pg || 1,
      sort: JSON.stringify(params.sort)
    },
  });
};

export const fetchProspectByEmail = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.PROSPECTS.GET_ALL,
    params: {
      coll: params.coll,
      fil: JSON.stringify(params.filters),
      postActions: JSON.stringify(["getJobDeatils"]),
      addedBy: params.addedBy,
    },
  });
};


export const getAccountCounts = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.JOBS.GET_ALL,
    params: {
      coll: params.coll,
      fil: JSON.stringify(params.filters),
      useAggregate: params.useAggregate ?? true,
    },
  });
};

export const addJobPosting = async (payload) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.JOBPOSTINGS.ADD,
    data: payload,
  });
};

export const updateJobPosting = async (payload) => {
  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.JOBPOSTINGS.UPDATE}?coll=${payload.coll}&uiid=${payload.uiid}`,
    data: payload,
  });
};

export const fetchCompanies = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.COMPANIES.GET_ALL}`,
    params: {
      coll: params.coll,
      lim: params?.lim ?? 10,
      pg: params?.pg ?? 1,
      ret: params?.ret || null,
      useAggregate: true,
      // fil: JSON.stringify({
      //   uiid: { type: "AG_ALL_ACCOUNTS", value: "" },
      // }),
      fil: JSON.stringify(params?.fil ?? {}),
      // extret: "uiid firstName",
      // extret: params?.extret || null, uncomment after solving issue,
      extret: params?.extret || null,
      sort: JSON.stringify(params.sort),
      ref: params?.ref || null,
    },
  });
};

export const fetchAllLeadsCount = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.SYSTEMSTATS.GET_ALL}`,
    params: {
      coll: params.coll,
      lim: params?.lim ?? 10,
      pg: params?.pg ?? 1,
      fil: JSON.stringify(params?.fil ?? {}),
    },
  });
};


export const fetchCompaniesFromDB = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.COMPANIES.GET_ALL}`,
    params: {
      coll: params.coll,
      lim: params?.lim ?? 10,
      pg: params?.pg ?? 1,
      ret: params?.ret || null,
      // fil: JSON.stringify({
      //   uiid: { type: "AG_ALL_ACCOUNTS", value: "" },
      // }),
      fil: JSON.stringify(params?.fil ?? {}),
      // extret: "uiid firstName",
      // extret: params?.extret || null, uncomment after solving issue 
      ref: params?.ref || null,
      incl: params?.incl || null
    },
  });
};

export const updateStatusAPI = async ({ coll, uiid, payload }) => {
  if (!coll || !uiid) {
    throw new Error("coll, uiid and status are required");
  }

  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.JOBS.UPDATE}?coll=${coll}&uiid=${uiid}`,
    data: {
      payload: payload,
    },
  });
};

export const getAccountDetailsById = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.COMPANIES.GET_BY_UIID,
    params: {
      coll: params.coll,
      fil: JSON.stringify(params.fil),
      ref: params.ref || null,
      ret: params.ret || null,
      extret: "uiid firstName role",
      extincl: "uiid name"
    },
  });
}

export const getAccountActivityDetails = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.JOBS.GET_ALL,
    params: {
      coll: params.coll,
      fil: JSON.stringify(params.fil),
      extret: params.extret,
      useAggregate: params.useAggregate,
      ref: params.ref || null,
      extincl: params.extincl
    },
  });
}
export const getAccountCardsCount = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.JOBPOSTINGS.GET_ALL,
    params: {
      coll: params.coll,
      fil: JSON.stringify(params.fil),
      useAggregate: params.useAggregate,
    },
  });
}

export const fetchAllProspects = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.PROSPECTS.GET_ALL}`,
    params: {
      coll: params.coll,
      pg: params.pg || 1,
      lim: params.lim || 10,
      ref: params.ref || null,
      ret: params.ret || null,
      fil: JSON.stringify(params.fil),
      extret: params.extret || null
    },
  });
};

export const updateCompanyDetails = async ({ coll, uiid, payload }) => {
  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.COMPANIES.UPDATE}?coll=${coll}&uiid=${uiid}`,
    data: {
      payload: payload,
    },
  });
};

export const fetchAllJobs = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.JOBS.GET_ALL}`,
    params: {
      coll: params.coll,
      pg: params.pg || 1,
      lim: params.lim || 10,
      ref: params.ref || null,
      ret: params.ret || null,
      incl: params.incl || null,
      fil: JSON.stringify(params.fil),
      extret: params.extret || null
    },
  });
};

export const addNote = async (payload) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.NOTES.ADD,
    data: payload,
  });
};

export const getNotes = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.NOTES.GET_ALL,
    params: {
      coll: params.coll,
      fil: JSON.stringify(params.filters),
      ret: param.ret || null,
      ref: params.ref || null,
      lim: params.lim || 10,
      pg: params.pg || 1,
      sort: JSON.stringify(params.sort),
      extret: params.extret
    },
  });
};

export const deleteNote = async (paylaod) => {
  return await axiosRequest({
    method: "DELETE",
    url: `${ENDPOINTS.NOTES.DELETE}`,
    data: {
      coll: paylaod.coll,
      uiid: paylaod.uiid,
    },
  });
}

export const fetchPendingCompanies = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.COMPANIES.GET_ALL}`,
    params: {
      coll: params.coll,
      lim: params?.lim ?? 10,
      pg: params?.pg ?? 1,
      ret: params?.ret || null,
      fil: JSON.stringify(params?.fil ?? {}),
      ref: params?.ref || null,
      extret: params?.extret || null,
      sort: JSON.stringify(params?.sort) || null,
      useAggregate: params.useAggregate,
    },
  });
};